import { Component } from '@angular/core';

@Component({
    selector: 'mon-base-state',
    template: '<div></div>',
})
export class BaseStateComponent {
    constructor () {}
}
